import { GetAppConfigSuccessAction, GET_APP_CONFIG_SUCCESS } from '../actions/appConfig';
import { AppConfig } from '../types';

type AppConfigActionTypes = GetAppConfigSuccessAction;

const appConfigReducer: (state: AppConfig, action: AppConfigActionTypes) => AppConfig = (state = null, action) => {
    switch (action.type) {
        case GET_APP_CONFIG_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default appConfigReducer;
